import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconChartColumn } from '@shared/assets/images/svgs';
import { UserRolesEnum } from '@shared/constants/auth.constants';
import { RootState, useAppSelector } from '@shared/store';
import CallAnalysisStructuredOutputSection from './CallAnalysisStructuredOutputSection';
import type { CallAnalysisActions } from './CallAnalysisStructuredOutputSection';

type HeaderSectionProps = {
  title: string;
};

const HeaderSection: React.FC<HeaderSectionProps> = ({ title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        'svg path': {
          stroke: theme.palette.getContrastText(theme.palette.background.default),
        },
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <IconChartColumn />
        <Typography fontSize="18px" fontWeight={600}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

type CallAnalysisGeneralProps = {
  campaignId: string;
  isSquadCampaign: boolean;
  onDirtyChange?: (isDirty: boolean) => void;
  onActionsChange?: (actions: CallAnalysisActions | null) => void;
};

const CallAnalysisGeneral: React.FC<CallAnalysisGeneralProps> = ({
  campaignId,
  isSquadCampaign,
  onDirtyChange,
  onActionsChange,
}) => {
  const { t } = useTranslation();
  const currentUser = useAppSelector((state: RootState) => state.auth.authenticatedUser);
  const analysisControlsDisabled = currentUser?.role === UserRolesEnum.VIEWER;

  return (
    <Box
      sx={{
        padding: '30px',
        width: '100%',
      }}>
      <HeaderSection title={t('campaignPage.editCampaign.callAnalysis')} />
      <Box>
        <CallAnalysisStructuredOutputSection
          campaignId={campaignId}
          isDisabled={analysisControlsDisabled}
          isSquadCampaign={isSquadCampaign}
          onDirtyChange={onDirtyChange}
          onActionsChange={onActionsChange}
        />
      </Box>
    </Box>
  );
};

export default CallAnalysisGeneral;
